import CT from '@marketplace-ai/tags';
import { EmptyState, FormDialog, TableCard } from '~/components';
import { BasicGrid } from '~/components/agGrid/Grid';
import { PROVIDER_PAGE_KEYS } from '~/routing/routes';
import { CertificateUpload } from './CertificateUpload';
import { InsuranceForm } from './InsuranceForm';
import { createInsuranceCols } from './tableConstants';
import { CreateMalpracticeInsuranceFormValues, MalpracticeInsuranceFormValues } from './types';

interface Props {
  data: MalpracticeInsuranceFormValues[];
  form: Partial<MalpracticeInsuranceFormValues>;
  loading: boolean;
  create: boolean;
  edit: boolean;
  handleEdit: (id: number) => void;
  handleDelete: (id: number) => void;
  triggerAddModal: () => void;
  handleClose: () => void;
  addInsurance: (values: CreateMalpracticeInsuranceFormValues) => void;
  editInsurance: (values: MalpracticeInsuranceFormValues) => void;
  onUploadCertificate?: (file: File) => void;
  uploadingCertificate?: boolean;
  parsingCertificate?: boolean;
}

const TAGS = CT.malpracticeInsurance.table;

const InsuranceNoRowsOverlay = () => (
  <EmptyState
    pageKey={PROVIDER_PAGE_KEYS.malpractice}
    title="No insurance records yet"
    cyTag={TAGS.emptyState}
  />
);

export const InsuranceDetails = (props: Props) => {
  const {
    data,
    loading,
    create,
    edit,
    handleEdit,
    handleDelete,
    triggerAddModal,
    handleClose,
    onUploadCertificate,
    uploadingCertificate = false,
    parsingCertificate = false,
  } = props;

  return (
    <>
      <TableCard
        mobilePageHeader
        title="Malpractice Insurance"
        addLabel="Add Malpractice Insurance"
        onAddClick={triggerAddModal}
        addBtnTag={TAGS.addBtn}
        layoutTag={CT.malpracticeInsurance.layout}
        customButtons={
          onUploadCertificate && (
            <CertificateUpload
              onUpload={onUploadCertificate}
              uploading={uploadingCertificate}
              parsing={parsingCertificate}
            />
          )
        }
      >
        <BasicGrid
          newRecordsTable="malpractice_insurances"
          data={data}
          loading={loading}
          colDefs={createInsuranceCols({ handleDelete, handleEdit })}
          pagination={true}
          cyTag={CT.malpracticeInsurance.grid}
          noRowsOverlayComponent={InsuranceNoRowsOverlay}
        />
      </TableCard>
      <FormDialog
        title={'Add New Insurance'}
        editing={edit}
        creating={create}
        onClose={handleClose}
      >
        <InsuranceForm {...props} />
      </FormDialog>
    </>
  );
};
